export default class MakePayment {
    constructor() {
        this.payment = document.querySelector('.make-payment');
        this.venmoBtn = document.querySelector('.venmo-btn');
        if (!this.payment || !this.venmoBtn) return;
        
        this.init();
        this.createVenmoLink();
    }
    
    init() {
        // Payment elements
        this.paymentHelpers = document.querySelectorAll('.payment-helper-box');
        this.amountInput = document.getElementById("payment-amount");
        this.noteInput = document.getElementById("payment-note");

        this.amount = "0.00";
        this.note = "";
        
        if (this.paymentHelpers.length) this.handlePaymentHelper();

        // Bind 'this' context so it doesn't lose reference to the class
        this.amountInput.addEventListener('input', this.handleAmountChange.bind(this));
        this.noteInput.addEventListener('input', this.handleNoteChange.bind(this));
    }
    
    // Helper Payment Boxes. Add predefined amount to inputs
    handlePaymentHelper() {
        this.paymentHelpers.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                
                this.amount = btn.dataset.amount;
                this.note = btn.dataset.note;
                
                if (this.amountInput) {
                    this.amountInput.value = this.amount;
                }
                
                if (this.noteInput) {
                    this.noteInput.value = this.note; 
                }

                // Update the deep link immediately upon clicking a helper box
                this.createVenmoLink();
            });
        });
    }

    handleAmountChange(e) {
        this.amount = e.target.value;
        this.createVenmoLink();
    }

    handleNoteChange(e) {
        this.note = e.target.value;
        this.createVenmoLink();
    }
    
    createVenmoLink() {
        let venmoHandle = this.venmoBtn.dataset.venmoHandle;
        let encodedNote = encodeURIComponent(this.note);

        if (!venmoHandle) return;
        // Strip out the '@' if the commissioner added it by mistake
        venmoHandle = venmoHandle.replace('@', '');

        this.venmoLink = `https://account.venmo.com/pay?amount=${this.amount}&note=${encodedNote}&recipients=${venmoHandle}&txn=pay`;
        this.venmoBtn.href = this.venmoLink;
    }
}